import { CloseOutlined } from '@ant-design/icons'
import { Button, Drawer } from 'antd'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { cardAtom } from '../../store/card'
import { ListPointDataType } from '../../types'

const PointItem = ({ point, price, handlePayment }: ListPointDataType) => {
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()
  const [card] = useRecoilState(cardAtom)
  const showDrawer = () => {
    localStorage.setItem('point', point.toString())
    setOpen(true)
  }

  const onClose = () => {
    setOpen(false)
  }
  return (
    <div className='flex justify-between items-center py-3'>
      <div className='flex justify-between items-center sm:w-32 w-24'>
        <img src='/logo.png' alt='NotBotti' className='sm:w-10 w-6' />
        <div className='text-white font-medium sm:text-xl text-lg'>
          {String(point).replace(/(.)(?=(\d{3})+$)/g, '$1,')}pt
        </div>
      </div>
      <Button
        type='primary'
        size='large'
        className='sm:w-72 w-32'
        onClick={showDrawer}
      >
        {new Intl.NumberFormat('ja-JP', {
          style: 'currency',
          currency: 'JPY'
        }).format(price)}
      </Button>
      <Drawer
        placement='bottom'
        closable={false}
        width={500}
        height={card ? 300 : 200}
        onClose={onClose}
        open={open}
      >
        <div className='flex justify-end'>
          <CloseOutlined style={{ fontSize: '150%' }} onClick={onClose} />
        </div>
        {card && (
          <Button
            type='primary'
            onClick={handlePayment}
            className='w-full my-6 h-20 text-lg'
          >
            クレジットカードでポイントを購入
            <div className='flex justify-center text-base p-3 gap-5'>
              <p>カード番号: {card.cardNumber}</p>
              <p>有効期限: {card.cardExpireAt}</p>
            </div>
          </Button>
        )}

        <Button
          onClick={() => navigate('/payment/card')}
          type='primary'
          className={`w-full mb-6 h-12 text-lg ${card ? 'mt-3' : 'mt-10'}`}
        >
          {card
            ? '別のクレジットカードでポイントを購入'
            : 'クレジットカードでポイントを購入'}
        </Button>
      </Drawer>
    </div>
  )
}

export default PointItem
